import moment from "moment";
import { MouseEventHandler, useState } from "react";

import { PlusIcon } from "../../icons/PlusIcon/PlusIcon";
import { MinimalProduct } from "../../types/product";
import { MaterialListItem } from "../MaterialListItem/MaterialListItem";

import euroIcon from "./euro_icon.png";
import styles from "./materials-list.module.css";

type MaterialsListProps = {
  title?: string | null;
  data: MinimalProduct[] | [];
  readOnly?: boolean;
  date?: string;
  plusIcon?: boolean;
  onClick?: MouseEventHandler<HTMLDivElement | HTMLLabelElement>;
};

export const MaterialsList = ({
  title,
  data,
  readOnly,
  date,
  plusIcon = false,
  onClick,
}: MaterialsListProps) => {
  const [editMode, setEditMode] = useState(false);

  const handleEuroClick = async () => {
    setEditMode((prev) => !prev);
  };

  return (
    <div className={styles["materials-list"]}>
      <div className={styles["materials-list__o"]}>
        {title && <h1 className={styles["materials-list__title"]}>{title}</h1>}

        {plusIcon && (
          <div className={styles["plus-icon"]} onClick={onClick}>
            <PlusIcon />
          </div>
        )}

        {!readOnly && (
          <img
            src={euroIcon}
            height="24"
            width="24"
            alt="Euro Icon"
            className={styles["plus-icon"]}
            onClick={handleEuroClick}
          />
        )}
      </div>

      {date && moment(date).isValid() && (
        <div className={styles["additional-text"]}>
          Hinzugefügt am: {moment(date).format("DD.MM.YYYY")}
        </div>
      )}

      <ul>
        {data?.map((product: MinimalProduct, i) => (
          <MaterialListItem
            key={i}
            product={product}
            readOnly={readOnly}
            editMode={editMode}
          />
        ))}
      </ul>
    </div>
  );
};
